export default __webpack_public_path__ + "static/media/bg1.20d3c306.jpg";